import type { IconData } from '@stacksjs/iconify-core'

export const shareBoxed: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464 248v216H48V48h216V16H16v480h480V216z\"/><path fill=\"currentColor\" d=\"M106.12 171.135A96.3 96.3 0 0 0 96 214.364v216.181h47.782l41.181-147.564a66.95 66.95 0 0 1 64.283-48.8H304V320h38.6l152.027-151.1L342.656 16H304v88h-93.818a114.4 114.4 0 0 0-104.062 67.135M336 136V54.7l113.373 114.058L336 281.441v-79.259h-86.754a99.055 99.055 0 0 0-95.105 72.2L128 368.051V214.364a64.6 64.6 0 0 1 6.879-29.2l.292-.614A82.36 82.36 0 0 1 210.182 136Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default shareBoxed
